<template>
  <div
    class="common-dialog-container"
    v-if="value"
    :style="{ backgroundColor: 'rgba(0, 0, 0, ' + maskOpacity + ')' }"
    :class="{ tile: closePosition === 'tile' }"
    @click.self="
      () => {
        closeOnClickModal && handleClose($event);
      }
    "
  >
    <div
      class="wrapper"
      :style="{ width: width }"
      :class="{ tile: closePosition === 'tile', fixed: fixed }"
    >
      <a
        href="javascript:;"
        class="close-btn"
        v-if="showClose"
        @mousedown="handleCloseBefore"
        @click="handleClose"
        :class="{
          outside: closePosition === 'outside',
          inside: closePosition === 'inside',
          tile: closePosition === 'tile',
          'blank-fill__small': blankFill === 'small'
        }"
      ></a>
      <div
        class="dialog-root"
        :class="{
          inside: closePosition === 'inside',
          tile: closePosition === 'tile',
          'blank-fill__small': blankFill === 'small'
        }"
      >
        <div
          class="dialog-header"
          :class="{
            'blank-fill__small': blankFill === 'small'
          }"
          v-if="closePosition === 'inside' && ($slots.header || title)"
        >
          <template v-if="$slots.header">
            <slot name="header"></slot>
          </template>
          <template v-if="title">
            <span class="title">{{ title }}</span>
          </template>
        </div>
        <div
          class="dialog-body"
          :class="{
            outside: closePosition === 'outside',
            'blank-fill__small': blankFill === 'small'
          }"
          v-if="$slots.body"
        >
          <slot name="body"></slot>
        </div>
        <div
          class="dialog-footer"
          :style="footerStyle"
          :class="{
            'blank-fill__small': blankFill === 'small'
          }"
          v-if="
            (closePosition === 'inside' || closePosition === 'tile') &&
              $slots.footer
          "
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "common-dialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "788px"
    },
    closePosition: {
      type: String,
      default: "inside"
      // "inside" || "outside" || "tile"
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    showMask: {
      type: Boolean,
      default: true
    },
    maskOpacity: {
      type: [Number, String],
      default: 0.6
    },

    footerStyle: {
      type: String,
      default: ""
    },

    title: {
      type: String,
      default: ""
    },

    fixed: {
      type: Boolean,
      default: false
    },

    blankFill: {
      type: String, // default || small
      default: "default"
    }
  },

  model: {
    prop: "value",
    event: "change"
  },

  data() {
    return {
      prevent: false
    };
  },
  watch: {
    value(val) {
      const root = document.documentElement;
      root.classList[val ? "add" : "remove"]("disabled-scroll");
    }
  },
  computed: {
    ...mapGetters("common", ["getDialogVisible"])
  },

  methods: {
    ...mapMutations("common", ["setDialogVisible"]),
    handleClose() {
      if (this.prevent) return;

      this.$emit("change", false);
      this.$emit("close", false);
    },

    handleCloseBefore() {}
  }
};
</script>
<style lang="less" scoped>
.common-dialog-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2001;

  overflow: auto;

  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.2);
  }

  ::-webkit-scrollbar-thumb {
    background-color: #008077;
    border-radius: 4px;
  }

  .wrapper {
    position: relative;
    margin: 15vh auto;
    padding: 37px;
    height: 70vh;

    &.fixed {
      display: flex;
      flex-direction: column;
      margin-top: 0;
      margin-bottom: 0;
      height: 100vh;
      overflow: hidden;

      .dialog-root {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .dialog-body {
        flex: 1;
        overflow-y: auto;
        margin-right: -55px;
        padding-right: 55px;

        &.blank-fill__small {
          margin-right: -35px;
          padding-right: 35px;
        }
      }
    }

    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      background-repeat: no-repeat;
      background-size: 100% 100%;

      &.outside {
        top: 10px;
        right: 10px;
        width: 17px;
        height: 17px;
        background-image: url("../../assets/confirmOrder/common_dialog_close_btn_bg1.png");
      }

      &.inside {
        top: 57px;
        right: 57px;
        width: 12px;
        height: 12px;
        background-image: url("../../assets/confirmOrder/common_dialog_close_btn_bg2.png");
      }
    }
  }

  .dialog-root {
    &.inside {
      padding: 40px 60px;
      border-radius: 8px;
      background-color: #fff;

      &.blank-fill__small {
        padding: 20px 40px;
      }

      @media (max-width: 1023px) {
        padding: 20px;
      }
    }
  }

  .dialog-header {
    position: relative;
    margin: -40px -60px 30px;
    padding: 40px 60px 24px;
    background-image: linear-gradient(
      90deg,
      #e5e5e5,
      #e5e5e5 60px,
      #008077 60px,
      #008077 125px,
      #e5e5e5 125px,
      #e5e5e5
    );
    background-repeat: no-repeat;
    background-position: 0 100%;
    background-size: 100% 4px;

    .title {
      font-size: 30px;
    }

    &.blank-fill__small {
      margin-top: -20px;
      margin-right: -40px;
      margin-left: -40px;
      padding-top: 20px;
      padding-right: 40px;
      padding-left: 40px;

      background-image: linear-gradient(
        90deg,
        #e5e5e5,
        #e5e5e5 40px,
        #008077 40px,
        #008077 105px,
        #e5e5e5 105px,
        #e5e5e5
      );
    }

    @media (max-width: 1023px) {
      margin: -20px -20px 20px;
      padding: 20px 20px 12px;
      background-image: linear-gradient(
        90deg,
        #e5e5e5,
        #e5e5e5 20px,
        #008077 20px,
        #008077 60px,
        #e5e5e5 60px,
        #e5e5e5
      );
      background-repeat: no-repeat;
      background-position: 0 100%;
      background-size: 100% 2px;
    }
  }

  .dialog-body {
    // max-height: 55vh;
    // overflow-x: hidden;
    // overflow-y: auto;

    &.outside {
      max-height: none;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;
    padding: 20px 0 0;
    border-top: 1px solid #cccccc;
  }

  &.tile {
    top: 66px;
    background-color: #fff !important;

    .wrapper {
      position: relative;
      width: auto !important;
      margin: 0 auto;
      padding: 20px;

      .close-btn {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        display: none;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.outside {
          top: 10px;
          right: 10px;
          width: 17px;
          height: 17px;
          background-image: url("../../assets/confirmOrder/common_dialog_close_btn_bg1.png");
        }

        &.inside {
          top: 57px;
          right: 57px;
          width: 12px;
          height: 12px;
          background-image: url("../../assets/confirmOrder/common_dialog_close_btn_bg2.png");
        }
      }
    }

    .dialog-root {
      &.inside {
        padding: 34px 20px;
        border-radius: 6px;
        background-color: #fff;
      }
    }

    .dialog-header {
      position: relative;
      margin: -28px -20px 0;
      padding: 28px 20px 16px;
      background-image: none;
      color: #000000;
      text-align: center;

      .title {
        font-size: 15px;
      }
    }

    .dialog-body {
      // max-height: 55vh;
      // overflow-x: hidden;
      // overflow-y: auto;

      &.outside {
        max-height: none;
      }

      img {
        max-width: 100%;
        height: auto;
      }
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      padding: 20px 0 0;
      border-top: 1px solid #cccccc;
    }
  }

  &.mobile {
    .wrapper {
      position: relative;
      width: auto !important;
      // margin: 0 auto;
      padding: 20px;

      .close-btn {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        // display: none;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.outside {
          top: 10px;
          right: 10px;
          width: 17px;
          height: 17px;
          background-image: url("../../assets/confirmOrder/common_dialog_close_btn_bg1.png");
        }

        &.inside {
          top: 37px;
          right: 37px;
          width: 12px;
          height: 12px;
          background-image: url("../../assets/confirmOrder/common_dialog_close_btn_bg2.png");
        }
      }
    }

    .dialog-root {
      &.inside {
        padding: 34px 20px;
        border-radius: 6px;
        background-color: #fff;
      }
    }

    .dialog-header {
      position: relative;
      margin: -28px -20px 0;
      padding: 28px 20px 16px;
      background-image: none;
      color: #000000;
      text-align: center;

      .title {
        font-size: 15px;
      }
    }

    .dialog-body {
      // max-height: 55vh;
      // overflow-x: hidden;
      // overflow-y: auto;

      &.outside {
        max-height: none;
      }

      img {
        max-width: 100%;
        height: auto;
      }
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      padding: 20px 0 0;
      border-top: 1px solid #cccccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonDialog/index.vue